import {div} from '@xh/hoist/cmp/layout';
import {percentRenderer, priceRenderer} from '@xh/hoist/format';

export const simplePriceFormatter = priceRenderer({
    precision: 2,
    ledger: false
});

export const priceFormatter: any = priceRenderer({
    precision: 2,
    prefix: '$',
    ledger: false
});

export const priceColorFormatter: any = priceRenderer({
    precision: 2,
    prefix: '$',
    colorSpec: true,
    ledger: false
});

export const moneyFormatter: any = priceRenderer({
    precision: 0,
    prefix: '$',
    ledger: false
});

export const moneyColorFormatter: any = priceRenderer({
    precision: 0,
    prefix: '$',
    colorSpec: true,
    ledger: false
});

export const percentFormatter: any = percentRenderer({
    precision: 2,
    colorSpec: true
});

export const percentPlainFormatter: any = percentRenderer({
    precision: 2
});

export function fmtLines(raw: string): React.ReactNode {
    const lines = raw.split('\n').map((line, idx) => div({key: idx, item: line}));
    return div(lines);
}

/** Compact count with a K / M / B suffix - e.g. 5.81M, 1.07B. */
export function compactNumberFormatter(v: number): string {
    if (v == null || !isFinite(v)) return null;
    const abs = Math.abs(v);
    if (abs >= 1e9) return `${(v / 1e9).toFixed(2)}B`;
    if (abs >= 1e6) return `${(v / 1e6).toFixed(2)}M`;
    if (abs >= 1e3) return `${(v / 1e3).toFixed(1)}K`;
    return `${Math.round(v)}`;
}
